<template>
  <div class="main-index">
    <div class="main-head">
      <img class="main-img" src="~@/assets/activity/learningStar/head-user.png" />
      <p class="head-btn flex-center award-btn" @click="handleAward">
        我的奖品
      </p>
      <p class="head-btn flex-center rule-btn" @click="showRule = true;currentTab=0">
        活动规则
      </p>
    </div>

    <div class="sticky-tab">
      <div class="tab-title-box">
        <a class="title-item flex-center" :class="{ on: tabActive === 1 }" @click="goAnchor('tab1')">
          个人学习之星
        </a>

        <a class="title-item flex-center" :class="{ on: tabActive === 2 }" @click="goAnchor('tab2')">
          机构学习之星
        </a>
        <a class="title-item flex-center" :class="{ on: tabActive === 3 }" @click="goAnchor('tab3')" v-if="isCustomer">
          邀学有礼
        </a>
        <a class="title-item flex-center" :class="{ on: tabActive === 4 }" @click="goAnchor('tab4')">
          排行榜
        </a>
      </div>
      <span class="learning-btn flex-center" v-if="activityStatus === '1'" @click="GoStudy">去学习，赢奖品</span>
      <span v-else class="learning-btn flex-center" >活动已结束</span>
    </div>
    <div class="body-content">
      <head-bar id="tab1" title="个人学习之星"></head-bar>
      <div class="rule-top half-w">
        <p class="rule-title ">
          <span class="point-icon"></span>根据学习热度由高到低每5分钟更新排名
        </p>
        <p class="rule-detail" @click="showPersonalRankRule = true">
          <span class="info-icon"></span>查看规则
        </p>
      </div>
      <div class="tab1">
        <div class="left">
          <div class="rule-sub-title">
            <span class="square-bg"></span>
            金融机构赛道奖项（面向恒生客户）
          </div>
          <ul>
            <li class="rule-con rule-con-title">
              <span class="col1">排名</span>
              <span class="col2">奖品</span>
            </li>
            <li class="rule-con" v-for="(item, index) in orgAward" :key="`org${index}`">
              <span class="col1">{{ item.rank }}</span>
              <span class="col2">{{ item.award }}</span>
            </li>
          </ul>
        </div>
        <div class="right">
          <div class="rule-sub-title">
            <span class="square-bg"></span>
            恒生电子赛道奖项（面向恒生员工）
          </div>
          <ul>
            <li class="rule-con rule-con-title">
              <span class="col1">排名</span>
              <span class="col2">奖品</span>
            </li>
            <li class="rule-con" v-for="(item, index) in innerAward" :key="`org${index}`">
              <span class="col1">{{ item.rank }}</span>
              <span class="col2">{{ item.award }}</span>
            </li>
          </ul>
        </div>
      </div>

      <head-bar id="tab2" title="机构学习之星"></head-bar>

      <div class="rule-top">
        <div>
          <p class="rule-title">
            <span class="point-icon"></span>
            <span class="rule-label">根据单机构学习人数由高到低每5分钟更新排名，活动期间学习人数≥100的TOP8机构开启单机构学习之星奖池</span>
          </p>
        </div>

        <p class="rule-detail" @click="showOrganRankRule = true">
          <span class="info-icon"></span>查看规则
        </p>
      </div>
      <div class="goods-items">
        <div class="goods-item" v-for="(item, index) in giftList" :key="index">
          <p class="goods-img"><img :src="item.img" /></p>
          <div class="goods-detail">
            <p class="goods-name">{{ item.name }}</p>
            <p class="goods-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>

      <head-bar id="tab3" title="邀学有礼" v-if="isCustomer"></head-bar>

      <giftOfInvite class="content-item" :shareUrl="shareUrl" v-if="isCustomer" @copy="copyLink"/>

      <head-bar id="tab4" title="排行榜"></head-bar>
      <my-info class="mt-20" :myInfo="myInfo" v-if="uPlusUser.user_type_str !== 'custom'" @showScoreTip="showPersonalRankRule = true"></my-info>
      <Rank></Rank>

      <div class="bottom-rule">
        <p class="title1">个人学习之星排行榜规则：</p>
        1、根据学习热度由高到低每5分钟更新排名<br />
        2、学习热度：本年度APP学习天数*25%+本年度PC学习天数*15%+本年度视频观看量（每个视频计一次，单视频学习时长需≥5分钟）*60%。（封顶统计视频观看量为1800）<br />
        3、学习热度相同时，则按本年度首次观看视频的先后顺序排列。<br />
        <p v-if="isCustomer"> 4、*每成功邀请一人学习，+200热度值。受邀人通过您分享的链接学习课程且已认证为恒生客户，即算邀请成功。（活动期间，若受邀人点击您的邀学链接前已有学习记录/已点击过他人分享的此活动链接，则不计入您的邀请战绩。）
        </p>
        <p v-if="isInner"> 4、*每成功邀请一人学习，+100热度值，最高+1000热度值。受邀人通过您分享的链接学习课程且已认证为恒生员工/恒生客户，即算邀请成功。（活动期间，若受邀人点击您的邀学链接前已有学习记录/已点击过活动链接，则不计入您的邀请战绩。）
        </p><br />
        <p class="title1"> 机构学习之星排行榜规则：</p>
        1、根据单机构学习人数由高到低每5分钟更新排名：<br />
        2、活动期间在U+课堂学习人数≥100的TOP8机构，开启人气机构奖池，开启奖池后按本机构内个人学习热度排名发放奖励。<br />
        3、学员学习热度＞0即计入机构学习人数（需认证为恒生客户）<br />
      </div>
    </div>

        <div class="copy-link" @click="copyLink">
          <span class="copy-link-bg"></span>
          复制
          邀请
          链接</div>

    <!--
      机构学习之星弹框-->
    <h-msg-box v-model="showOrganRankRule" width="500" :zIndex="1000" :mask-closable="false" class="rule-modal wrapper-award">
      <p slot="header">
        <span class="square-bg"></span>
        <span>机构学习之星排行规则</span>
      </p>

      <div class="rule-dialog-content">
        <p>1、根据学习人数由高到低每5分钟更新排名；</p>

        <p>
          2、活动期间在U+课堂学习人数≥100的TOP8机构，开启人气机构奖池，开启奖池后按本机构内个人学习热度排名发放奖励。
        </p>
      </div>
      <div>

      </div>
      <div slot="footer">
        <p class="btn award-btn" @click="showOrganRankRule = false">知道了</p>
      </div>
    </h-msg-box>
    <!--
      个人学习之星弹框-->
    <h-msg-box v-model="showPersonalRankRule" width="500" :zIndex="1000" :mask-closable="false" class="rule-modal wrapper-award">
      <p slot="header">
        <span class="square-bg"></span>
        <span>个人之星赛道规则</span>
      </p>

      <div class="rule-dialog-content">
        <p>1、根据学习热度由高到低每5分钟更新排名；</p>

        <p>
          2、学习热度：本年度APP学习天数*25%+本年度PC学习天数*15%+本年度视频观看量（每个视频计一次，单视频学习时长需≥5分钟）*60%。（封顶统计视频观看量为1800）
        </p>

        <p>3、学习热度相同时，则按本年度首次观看视频的先后顺序排列。</p>

        <p v-if="isCustomer">
          *每成功邀请一人学习，+200热度值。受邀人通过您分享的链接学习课程且已认证为恒生客户，即算邀请成功。
          （活动期间，若受邀人点击您的邀学链接前已有学习记录/已点击过他人分享的此活动链接，则不计入您的邀请战绩。）
        </p>
         <p v-if="isInner"> 4、*每成功邀请一人学习，+100热度值，最高+1000热度值。受邀人通过您分享的链接学习课程且已认证为恒生员工/恒生客户，即算邀请成功。（活动期间，若受邀人点击您的邀学链接前已有学习记录/已点击过活动链接，则不计入您的邀请战绩。）
        </p>
      </div>
      <div>

      </div>
      <div slot="footer">
        <p class="btn award-btn" @click="showPersonalRankRule = false">知道了</p>
      </div>
    </h-msg-box>
    <!--
      我的奖品-->
    <h-msg-box v-model="showMyAward" width="500" :zIndex="1000" :mask-closable="false" class="rule-modal wrapper-award">
      <p slot="header">
        <span class="square-bg"></span>
        <span>我的奖品</span>
      </p>

      <div class="no-award" v-if="prizeList.length == 0">
        <p class="award-title">暂无奖品</p>
        <p class="award-title-light">快去邀请同事一起学习赢奖品吧～</p>
      </div>
      <div v-else>
        <div class="award-box">
          <div class="award-item" v-for="(item,index) in prizeList" :key="item.prize_id+''+index">
            <div class="award-name ellipsis">
              <span class="point-icon-sm"></span> <span class="ellipsis">{{ item.prize_name || "--" }}</span>
            </div>
            <div class="award-time ellipsis">获取时间：{{ item.draw_time || "--" }}</div>
          </div>
        </div>
        <template v-if="haveMaterialPrize">
          <canvas id="QRCode" style="width: 100px; height: 100px" class="qr-code"></canvas>
          <!-- <img src="" alt="" class="qr-code" /> -->
          <span class="scan-tip">使用恒生U+APP扫码填写邮寄地址</span>
          <div class="post-tip">实物奖于活动结束后10个工作日内寄出</div>
        </template>
      </div>
      <div>

      </div>
      <div slot="footer">
        <p class="btn award-btn" @click="showMyAward = false">知道了</p>
      </div>
    </h-msg-box>
    <!--活动规则-->
    <h-msg-box v-model="showRule" width="700" :zIndex="1000" :mask-closable="false" class="rule-modal">
      <p slot="header">
        <span class="square-bg"></span>
        <span>活动规则</span>
      </p>
      <div>
        <ul class="rank-tab">
          <li v-show="isCustomer||index!==2" :class="{ active: currentTab == index ,'rank-tab-2':ruleTabs.length==2 }" @click="currentTab=index" v-for="(item, index) in ruleTabs" :key="index">{{ item }}</li>
        </ul>
        <div class="rank-content" v-if="currentTab==0">
          <div class="rule-box">
            <p class="title2">
              排行榜规则:<br />
              1、根据学习热度由高到低每5分钟更新排名<br />
              2、学习热度：本年度APP学习天数*25%+本年度PC学习天数*15%+本年度视频观看量（每个视频计一次，单视频学习时长需≥5分钟）*60%。（封顶统计视频观看量为1800）<br />
              3、学习热度相同时，则按本年度首次观看视频的先后顺序排列。
            </p>
            <p v-if="isCustomer"> 4、*每成功邀请一人学习，+200热度值。受邀人通过您分享的链接学习课程且已认证为恒生客户，即算邀请成功。（活动期间，若受邀人点击您的邀学链接前已有学习记录/已点击过他人分享的此活动链接，则不计入您的邀请战绩。）
            </p>
            <p v-if="isInner"> 4、*每成功邀请一人学习，+100热度值，最高+1000热度值。受邀人通过您分享的链接学习课程且已认证为恒生员工/恒生客户，即算邀请成功。（活动期间，若受邀人点击您的邀学链接前已有学习记录/已点击过活动链接，则不计入您的邀请战绩。）
            </p>
            <br />
            <p class="title2">
              金融机构赛道奖项：（面向恒生客户）<br />
            <p class="pl-24" v-for="(item,index) in orgAward" :key="`org${index}`"> {{item.rank}}:{{item.award}}</p>
            </p>

            <p class="title2">
              恒生电子赛道奖项：（面向恒生员工）<br />
            <p class="pl-24" v-for="(item,index) in innerAward" :key="`inner${index}`"> {{item.rank}}:{{item.award}}</p>
            </p>
            <br />
            <p class="title2">
              *视频观看量义说明：在2022年观看一个视频计一个观看量。如一个课程下有3个视频，每观看一个视频计一个观看量，同一视频重复多天/次观看，最多仅计一个观看量(单视频学习时长需≥5分钟)。<br />
              *APP打卡天数定义说明：在APP课堂，日学习时长≥5分钟的天数。<br />
              *PC打卡天数定义说明：在PC课堂，日学习时长≥5分钟的天数。
              （同一个视频同一天先后在APP、PC学习均≥5分钟，则仅计入APP天数）

            </p>
            <br />
            <p class="title2">
              活动结束后，根据个人学习之星排行结果，发放对应奖品。(学习热度需＞0方能获得排名及奖品)。当个人学习热度相同时，则按本年度首次观看视频的先后顺序排列。
            </p>
            <br />
            <p class="title2">
              奖品发放：将于活动结束后10个工作日内陆续发放<br />
              如需寄送：在【我的奖品】填写邮寄地址（支持填写一次）<br />
              <!-- 活动咨询：高莉莉 0571-26691748<br />
                本活动解释权归恒生电子股份有限公司所有 -->
            </p>
            <!-- <p class="title2 alignCenter">本活动解释权归恒生电子股份有限公司所有</p> -->
          </div>
        </div>
        <div class="rank-content" v-if="currentTab==1">
          <div class="rule-box">
            <p class="title2">
              排行榜规则：<br />
              1、根据学习人数每5分钟更新排名：<br>
              2、活动期间在U+课堂学习人数≥100的TOP8机构，开启人气机构奖池，开启奖池后按本机构内个人学习热度排名发放奖励。<br />
              3、学员学习热度＞0即计入机构学习人数（需认证为恒生客户）
            </p>

            <p class="title2">
              机构学习之星奖项：（面向金融机构）</p>
            <p class="title2 pl-24"> 第1-3名：筋膜枪</p>
            <p class="title2 pl-24"> ≥第4名：2000U豆</p>

            <p class="title2">
              活动结束后，在U+课堂学习人数≥100的TOP8机构，开启人气机构奖池，开启奖池后按本机构内个人学习热度排名发放奖励。学员学习热度需＞0方能获得排名及奖品，当个人学习热度相同时，则按本年度首次观看视频的先后顺序排列。
            </p>
            <br />
            <p class="title2">
              奖品发放：将于活动结束后10个工作日内陆续发放 <br />
              如需寄送：在【我的奖品】填写邮寄地址（支持填写一次）<br />
              <!-- 活动咨询：高莉莉 0571-26691748<br />
                本活动解释权归恒生电子股份有限公司所有 -->
            </p>

            <!-- <p class="title2 alignCenter">本活动解释权归恒生电子股份有限公司所有</p> -->
          </div>
        </div>
        <div class="rank-content" v-if="currentTab==2">
          <div class="rule-box">
            <p class="title2">
              活动期间，您可分享活动链接邀请同事一起学，受邀人通过您分享的链接学习课程且已认证为恒生客户，即算邀请成功。<br>
              （活动期间，若受邀人点击您的邀学链接前已有学习记录/已点击过他人分享的此活动链接，则不计入您的邀请战绩。）

            </p>
            <br />
            <p class="title2">
              ·每成功邀请一人计1个积分，积分可兑换下方奖品。<br /></p>
            <p class="title2"> ·每兑换一份奖品，将扣除相应的积分。</p>

            <br />

            <p class="title2">
              可兑换奖励：<br />
              10积分兑换5000U豆，共100份，先到先得。<br />
              20积分兑换花王眼罩一盒，共25份，先到先得。<br />
              50积分兑换萌趣大肚杯一个，共10份，先到先得。<br />
              100积分兑换筋膜枪一个，共10份，先到先得。<br />
            </p>
            <br />
            <p class="title2">
              奖品发放：将于活动结束后10个工作日内陆续发放<br />
              如需寄送：在【我的奖品】填写邮寄地址（支持填写一次）<br />
              <!-- 活动咨询：高莉莉 0571-26691748<br />
                本活动解释权归恒生电子股份有限公司所有 -->
            </p>
          </div>
        </div>

      </div>
      <div slot="footer">
        <p class="rule-connect">

          活动咨询：高莉莉 0571-26691748<br />
          本活动解释权归恒生电子股份有限公司所有
        <p class="btn award-btn" @click="showRule = false">知道了</p>
      </div>
    </h-msg-box>
    <!-- 身份认证弹窗 -->
    <h-msg-box v-model="showAuthModal" width="400" title="身份认证" :zIndex="1000" :mask-closable="false" class="operate-task-modal">
      <div class="auth-dialog-box">
        <p>您尚未进行身份认证，认证后可观看更多直播内容!</p>
      </div>
      <h-button type="primary" @click="goAuth" slot="footer">立即认证</h-button>
    </h-msg-box>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { goAuth } from "@/utils/toUplus";
// import Rule from "./components/rule";
import HeadBar from "./components/HeadBar.vue";
import giftOfInvite from "./components/giftOfInvite.vue";
import MyInfo from "./components/myInfo.vue";
import Rank from "./components/Rank.vue";
import { orgAward, innerAward, inviteGift, giftList } from "./config";
import {
  sharing,
  getActivtyStatus,
  getuserdrawprizelist,
  ulActInviteStudyStar,
  getMyLearning4ss,
} from "@/api/uPlusApi/learning.js";
import QRCode from "qrcode"; // 生成二维码插件
export default {
  components: { HeadBar, giftOfInvite, MyInfo, Rank },
  name: "LearningStar",
  data() {
    return {
      shareAction: "studyStar",
      shareUrl:'',
      activityStatus: 0,
      showAuthModal: false,
      tabActive: 1,
      orgAward,
      innerAward,
      inviteGift,
      giftList,
      showRule: false,
      ruleTabs: ["个人学习之星", "机构学习之星", "邀学有礼"],
      currentTab: 0,
      showMyAward: false,
      prizeList: [],
      haveMaterialPrize: false,
      showPersonalRankRule: false,
      showOrganRankRule: false,
      myInfo: {
        total_time: 0,
        days: 0,
        score: 0,
        rank_no: 0,
      },
    };
  },
  computed: {
    ...mapGetters(["uPlusUser"]),
    isCustomer() {
      return this.uPlusUser
        ? this.uPlusUser.user_type_str.indexOf("outerOrg") > -1
        : false;
    },
    isInner(){
      return this.uPlusUser
        ? this.uPlusUser.user_type_str.indexOf("innerOrg") > -1
        : false;
    }
  },
  methods: {
    goAuth,
    getShareLink() {
      const shareParams = {
        shareTitle: 'U+年度学习之星',
        shareContent:'学有所用，学有所得，最高10万U豆悬赏学习之星',
        shareAction: "",
        uniqueId: "",
        extendPrams: {},
      };

      const shareImg = 'https://www.hs.net/r/cms/www/openplatWeb/images/share-min.png';
      sharing({
        channel: "weixin",
        app_key: "",
        action: this.shareAction,
        unique_id: this.shareAction,
        params: {
          image: shareImg,
          title: shareParams.shareTitle,
          content: shareParams.shareContent,
          ...shareParams.extendPrams,
          url: `${window.LOCAL_CONFIG.onlineClassUrl}/banner-home/i/LearningStar-2022/#/`
        }
      }).then((res) => {
       
        if (res) {
           this.shareUrl = res.url
          // this.shareUrl = res.url.replace(
          //   /(.*)(?=s_id)/,
          //   location.origin + location.pathname + "?"
          // );
        }
      });
    },
    copyLink() {
      // let url = p;
      let oInput = document.createElement("input");
      oInput.value = this.shareUrl;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy");
      this.$hMessage.success({
        content: "复制成功",
        successTop: 500,
      });
      document.body.removeChild(oInput)
    },
    GoStudy() {
      if (this.uPlusUser.user_type_str === "custom") {
        this.showAuthModal = true;
        return;
      } else {
        window.open("/openplat-front/courseIndex");
      }
    },
    handleAward(){
      this.getPrizeList()
      this.showMyAward = true;
    },

    // 生成二维码
    genQrCode() {
      let msg = document.getElementById("QRCode");
      QRCode.toCanvas(
        msg,
        `${window.LOCAL_CONFIG.onlineClassUrl}/qr/i/LearningStar-2022/#/?goUmall=1`,
        function (error) {}
      );
    },
    async getPrizeList() {
      const res = await getuserdrawprizelist();
      if (res) {
        const _res = res.rows;
        if (_res && _res.length === 0) {
          this.prizeList = [];
          this.haveMaterialPrize = false;
        } else {
          this.prizeList = _res;
          _res.forEach((item) => {
            if (String(item.prize_type) === "1") {
              this.haveMaterialPrize = true;
            }
          });
          if (this.haveMaterialPrize) {
            this.$nextTick(this.genQrCode);
          }
        }
      }
    },
    GetMyInfo() {
      getMyLearning4ss().then((res) => {
        this.myInfo = res;
      });
    },
    goAnchor(selector) {
      let top = document.getElementById(selector).offsetTop - 50;
      console.log("top", top);
      if (selector == "tab1") {
        window.scrollTo({
          top: 441,
          behavior: "smooth",
        });
      } else {
        window.scrollTo({
          top: top,
          behavior: "smooth",
        });
      }
    },
    handleScroll() {
      // 获取滚动时的高度
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (document.getElementById("tab3")) {
        if (scrollTop < document.getElementById("tab2").offsetTop - 100)
          this.tabActive = 1;
        else if (
          scrollTop >= document.getElementById("tab2").offsetTop - 100 &&
          scrollTop < document.getElementById("tab3").offsetTop - 100
        )
          this.tabActive = 2;
        else if (
          scrollTop >= document.getElementById("tab3").offsetTop - 100 &&
          scrollTop < document.getElementById("tab4").offsetTop - 100
        )
          this.tabActive = 3;
        else if (scrollTop >= document.getElementById("tab4").offsetTop - 100)
          this.tabActive = 4;
      } else {
        if (scrollTop < document.getElementById("tab2").offsetTop - 100)
          this.tabActive = 1;
        else if (
          scrollTop >= document.getElementById("tab2").offsetTop - 100 &&
          scrollTop < document.getElementById("tab4").offsetTop - 100
        )
          this.tabActive = 2;
        else if (scrollTop >= document.getElementById("tab4").offsetTop - 100)
          this.tabActive = 4;
      }
    },
    getActivityInfo(){
      getActivtyStatus({
        activity_id: "studyStar"
      }).then((res) => {
        if(!res) return
        this.activityStatus = res.status;
      });
    }
  },
  created(){
    if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
        // 当前设备是移动设备
        location.replace(`${window.LOCAL_CONFIG.onlineClassUrl}/banner-home/i/LearningStar-2022/#/`+location.search)
      }
  },
  mounted() {

    ulActInviteStudyStar({
      activity_id: "studyStar", //	活动id
      sharing_id: this.$route.query.s_id || "", //	分享id
    });
    this.getShareLink();
    this.getActivityInfo();
    this.getPrizeList();
    this.GetMyInfo();
    

    this.$nextTick(() => {
      this.scrollTop =
        document.body.scrollTop ||
        document.documentElement.scrollTop ||
        window.pageYOffset;
      window.addEventListener("scroll", this.handleScroll);
    });
  },
};
</script>
<style lang="scss" scoped>
.copy-link{
  position: fixed;
  bottom: 100px;
    background: #C5E2FF;
    border-radius: 25px;
    width: 40px;
    // height: 100px;
    padding: 10px 0;
    right: calc(50% - 600px - 50px);
    font-size: 14px;
    color: #1A529B;
    font-family: PingFangSC-Regular;
    cursor: pointer;
    text-align: center;
    .copy-link-bg{
      width: 20px;
      height: 20px;
       background: url("~@/assets/activity/learningStar/link.png") no-repeat;
           display: block;
    background-size: contain;
    margin: 0 auto ;
    }
}
.mt-20 {
  margin-top: 20px;
}
.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.square-bg {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: #506fe9;
  border: 2px solid rgba(35, 64, 176, 1);
  margin-right: 8px;
}
.point-icon {
  background: #dce4ff;
  border: 2px solid rgba(92, 121, 230, 1);
  width: 8px;
  height: 8px;
  border-radius: 4px;
  flex-shrink: 0;
  margin: 7px 4px 7px 0;
}
.point-icon-sm {
  background: #dce4ff;
  border: 1px solid rgba(92, 121, 230, 1);
  width: 4px;
  height: 4px;
  margin: 5px 6px 5px 0;
  border-radius: 4px;
}
.main-index {
  background: #5c79e6;
  font-family: AlibabaPuHuiTi-Regular;
  .main-head {
    width: 1200px;
    //  width: 1200px;
    margin: 0 auto;
    position: relative;
    .main-img {
      width: 1290px;
      margin-top: 30px;
      margin-left: -45px;
    }
    .head-btn {
      width: 81px;
      height: 38px;
      background: #ffe57c;
      border: 1px solid #2340b0;
      box-shadow: 1px 2px 0 0 #2340b0, inset -4px -5px 0 0 #ffac55,
        inset 3px 3px 0 0 #ffffff;
      border-radius: 19px;
      font-size: 16px;
      color: #2340b0;
      cursor: pointer;
    }
    .award-btn {
      position: absolute;
      top: 20px;
      right: 0;
    }
    .rule-btn {
      position: absolute;
      top: 20px;
      right: 89px;
    }
  }
  .sticky-tab {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    position: sticky;
    top: 0;
    background-color: #5c79e6;
    z-index: 99;
    .tab-title-box {
      // background: #dce4ff;
      // border: 1px solid rgba(35, 64, 176, 1);
      border-radius: 36px 0px 0px 0px;
      display: flex;
      .title-item {
        background: #3f60e2;
        border: 1px solid rgba(35, 64, 176, 1);
        width: 217px;
        height: 50px;
        font-size: 20px;
        color: #ffffff;
        font-family: AlibabaPuHuiTi-Medium;
        font-weight: 500;
        &.on {
          background: #dce4ff;
          color: #2340b0;
        }
      }
      :first-child {
        // background: #dce4ff;
        border: 1px solid rgba(35, 64, 176, 1);
        border-radius: 36px 0px 0px 0px;
      }
      :last-child {
        // background: #3f60e2;
        border: 1px solid rgba(35, 64, 176, 1);
        border-radius: 0px 36px 0px 0px;
      }
    }
    .learning-btn {
      font-family: AlibabaPuHuiTi-Medium;
      font-size: 20px;
      font-weight: 500;
      color: #2340b0;
      width: 223px;
      height: 45px;
      padding-right: 45px;
      background: url("~@/assets/activity/learningStar/rank-bg.png") no-repeat
        center center;
      background-size: contain;
      cursor: pointer;
    }
  }

  .body-content {
    width: 1200px;
    margin: 0 auto;
    background: #dce4ff;
    border: 1px solid rgba(35, 64, 176, 1);
    border-radius: 2px;
    padding: 19px 40px 40px;
    .tab1 {
      display: flex;
      justify-content: space-between;
      margin-bottom: 35px;
      .left {
        width: 550px;
      }
      .right {
        width: 550px;
      }
    }
    .half-w {
      width: 550px;
    }
    .rule-top {
      margin-top: 15px;
      margin-bottom: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .rule-title {
      font-family: AlibabaPuHuiTi-Regular;
      font-size: 16px;
      color: #5c79e6;
      letter-spacing: 0;
      text-align: center;
      text-align: left;
      display: flex;
      flex-shrink: 0;
    }

    .rule-title-dark {
      color: #2340b0;
    }
    .rule-detail {
      width: 86px;
      font-family: AlibabaPuHuiTi-Regular;
      font-size: 16px;
      color: #5c79e6;
      display: flex;
      align-items: center;
      text-decoration: underline;
      justify-content: flex-end;
      cursor: pointer;
      .info-icon {
        display: inline-block;
        width: 16px;
        height: 16px;
        margin-right: 4px;
        background: url("~@/assets/activity/learningStar/info.png") 50% 50%
          no-repeat;
        background-size: contain;
      }
    }
    .rule-sub-title {
      font-family: AlibabaPuHuiTi-Regular;
      font-size: 20px;
      color: #2340b0;
      text-align: center;
      margin-bottom: 14px;
      text-align: left;
      display: flex;
      align-items: center;
    }
    .rule-con {
      background: #ffffff;
      border: 2px solid rgba(35, 64, 176, 1);
      border-radius: 2.88px;
      height: 50px;
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      font-family: AlibabaPuHuiTi-Regular;
      font-size: 24px;
      color: #2340b0;
      text-align: center;
      font-weight: 400;
      .col1 {
        flex: 1;
      }
      .col2 {
        flex: 1;
      }
      .highlight {
        color: #ff6800;
      }
    }
    .rule-con-title {
      background: #c4d0ff;
    }
    .rule-goods {
      background: #ffffff;
      border: 2px solid rgba(35, 64, 176, 1);
      border-radius: 4px;
      padding: 0 19px 40px;
      width: 640px;
      margin: 0 auto;
    }
    .goods-items {
      display: flex;
      justify-content: space-between;
      margin-bottom: 40px;
    }
    .goods-item {
      border-radius: 4px 0px 0px 4px;
      width: 550px;
      height: 180px;
      display: flex;
      .goods-img {
        width: 393px;
        height: 180px;
        background: #c4d0ff;
        border: 1px solid rgba(35, 64, 176, 1);
        border-radius: 2px 0px 0px 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
      .goods-detail {
        background: #f3f6ff;
        border: 1px solid rgba(35, 64, 176, 1);
        border-radius: 0px 2px 2px 0px;
        border-left: none;
        width: 157px;
        height: 180px;
      }
      .goods-name {
        font-size: 24px;
        color: #2340b0;
        font-weight: 400;
        padding-top: 58px;
        // padding-left: 8px;
        text-align: center;
      }
      .goods-desc {
        font-size: 20px;
        color: #5c79e6;
        font-weight: 400;
        padding-left: 8px;
        padding-top: 8px;
        text-align: center;
      }
    }
  }
}
.rule-modal {
  .award-btn {
    background: #ffd52d;
    border: 1px solid #2340b0;
    box-shadow: 1px 2px 0 0 #5c79e6, inset -2px -3px 0 0 #ff6800,
      inset 2px 2px 0 0 #ffffff;
    border-radius: 18px;
    width: 140px;
    height: 36px;
    display: flex;
    margin: 10px auto;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: #2340b0;
    cursor: pointer;
  }
  /deep/ .h-modal-content {
    background: #dce4ff;
    border: 1px solid rgba(35, 64, 176, 1);
    border-radius: 2px;
  }
  /deep/ .h-modal-header {
    border-bottom: none;
    padding: 10px;
    font-size: 18px;
    color: #2340b0;
    > p {
      display: flex;
      color: #2340b0;
    }
    .square-bg {
      width: 18px;
      height: 18px;
      line-height: 18px;
    }
  }
  /deep/ .h-modal-close {
    right: 10px;
    top: 10px;
  }
  /deep/ .h-modal-body {
    padding: 3px 10px 0;
    p {
      font-size: 14px;
      color: #5c79e6;
    }
  }
  /deep/ .h-modal-footer {
    border-top: none;
    text-align: center;
    padding: 10px;
  }

  .rank-tab {
    display: inline-block;
    border: 1px solid rgba(35, 64, 176, 1);
    border-bottom: 0;
    border-radius: 2px;
    height: 26px;
    align-items: center;
    // margin-bottom: 20px;
    background: #fff;
    color: #2340b0;
    li {
      display: inline-block;
      width: 100px;
      height: 26px;
      line-height: 26px;
      text-align: center;
      cursor: pointer;
      &.active {
        background: #506fe9;
        border-radius: 2px;
        color: #ffffff;
      }
    }
    // .rank-tab-2 {
    //   width: 50%;
    // }
  }
  .rule-connect {
    font-size: 14px;
    color: #5c79e6;
  }
  .rank-content {
    background: #ffffff;
    border: 1px solid rgba(35, 64, 176, 1);
    border-radius: 2px;
    padding: 20px;
    font-size: 14px;
    color: #5c79e6;
    height: 280px;
    overflow-y: auto;
    > p {
      color: #5c79e6;
    }
  }
}
.wrapper-award {
  .qr-code {
    width: 100px;
    height: 100px;
    display: block;
    padding: 10px;
    margin: 0 auto 10px;
  }
  .scan-tip {
    color: #004cff;
    text-align: center;
    display: block;
  }
  .post-tip {
    text-align: center;
    font-size: 12px;
    color: #5c79e6;
  }
  .award-box {
    min-height: 248px;
    max-height: 300px;
    overflow-y: auto;
  }

  .award-item {
    background: #ffffff;
    border: 1px solid rgba(35, 64, 176, 1);
    border-radius: 2px;
    height: 58px;
    width: 100%;
    margin-bottom: 8px;
    margin-top: 8px;
    padding: 10px 12px;
    &:first-child {
      margin-top: 0px;
    }
    .award-name {
      display: flex;
      font-size: 16px;
      color: #5c79e6;
      line-height: 1;
    }
    .award-time {
      font-family: AlibabaPuHuiTi-Regular;
      font-size: 14px;
      color: #99aeff;
      letter-spacing: 0;
      font-weight: 400;
      text-align: left;
      padding-left: 10px;
      margin-top: 2px;
    }
  }
  // .award-title {
  //   font-family: AlibabaPuHuiTi-Regular;
  //   font-size: 24px;
  //   color: #5c79e6;
  //   letter-spacing: 0;
  //   text-align: center;
  //   line-height: 36px;
  //   font-weight: 400;
  //   margin-top: 32px;
  // }
  // .award-title-dark {
  //   font-family: AlibabaPuHuiTi-Regular;
  //   font-size: 24px;
  //   color: #2340b0;
  //   letter-spacing: 0;
  //   text-align: center;
  //   line-height: 36px;
  //   font-weight: 400;
  //   margin-top: 8px;
  //   text-decoration: underline;
  // }
  // .award-title-light {
  //   font-size: 24px;
  //   color: #99aeff;
  // }
  .award-btn {
    background: #ffd52d;
    border: 1px solid rgba(35, 64, 176, 1);
    box-shadow: inset -2px -3px 0px 0px rgba(255, 104, 0, 1);
    box-shadow: inset 2px 2px 0px 0px rgba(255, 255, 255, 1);
    box-shadow: 1px 2px 0px 0px rgba(92, 121, 230, 1);
    border-radius: 18px;
    width: 140px;
    height: 36px;
    display: flex;
    margin: 0 auto 10px;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: #2340b0;
  }
  .no-award {
    height: 148px;
    background: #ffffff;
    border: 1px solid rgba(35, 64, 176, 1);
    border-radius: 2px;
    margin-top: 0;
    text-align: center;
    .award-title {
      margin-top: 46px;
      font-size: 16px;
      color: #5c79e6;
    }
    .award-title-light {
      margin-top: 10px;
      color: #99aeff;
    }
  }
}
.rule-dialog-content {
  background: #ffffff;
  border: 1px solid rgba(35, 64, 176, 1);
  border-radius: 2px;
  padding: 16px;
  max-height: 460px;
  overflow-y: auto;
}
.bottom-rule {
  background: #f3f6ff;
  border: 1px solid rgba(35, 64, 176, 1);
  border-radius: 2px;
  padding: 20px;
  margin-top: 40px;
  font-size: 16px;
  color: #5c79e6;
  letter-spacing: 0;
  line-height: 24px;
  .title1 {
    font-size: 18px;
    color: #2340b0;
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/activities/learningStar/learningStar.vue